<template>

    <div class="spa pb-sm-5 pb-4">
        <cancel></cancel>
        <div class=" start">
            <div class="booking-container-n">

                <div class="page-intro">
                    <h1>{{content.heading}}</h1>
                    <div v-html="content.intro"></div>


                    <a v-bind:href="content.brochure.Url" target="_blank"
                       class="btn btn--transparent-dark btn--highlight-after">
                        {{content.brochure.Name}}
                    </a>

                </div>

                <div class="row mb-5 " v-if="isDisabled">
                    <div class="col-xl-24 text-center">
                        <div class=" p-3 bg-white" v-html="spaStatus.BookingMessage">
                        </div>
                    </div>
                </div>



                <div class="row" v-else>


                    <div class="col-xl-12 mb-4 mb-xl-0 ">
                        <div class="d-flex flex-column  bg-white h-100">
                            <div class="type-gallery">
                                <single-image-gallery v-bind:images="content.spaDay.images"></single-image-gallery>
                            </div>
                            <div class="d-flex flex-column bg-white p-4 flex-grow-1">
                                <div class="mb-4">
                                    <h3>{{content.spaDay.displayName}}</h3>
                                </div>
                                <div class="d-flex flex-column justify-content-between h-100">
                                    <div v-html="content.spaDay.description"></div>

                                    <div class="btn-container btn-container--start mt-4">
                                        <a v-on:click="onBookSpaDay()"
                                           class="btn btn--slate-blue">Book</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="col-xl-12">
                        <div class="d-flex flex-column  bg-white h-100">
                            <div class="type-gallery">
                                <single-image-gallery v-bind:images="content.spaTreatment.images"></single-image-gallery>
                            </div>
                            <div class="d-flex flex-column bg-white p-4 flex-grow-1">
                                <div class="mb-4">
                                    <h3>{{content.spaTreatment.displayName}}</h3>
                                </div>
                                <div class="d-flex flex-column justify-content-between h-100">
                                    <div v-html="content.spaTreatment.description"></div>
                                    <div class="btn-container btn-container--start mt-4">
                                        <a v-on:click="onBookSpaTreatment()"
                                           class="btn btn--slate-blue ">Book</a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>


            </div>
        </div>
    </div>
</template>
<script>
    import { store } from '../store/index';

    import Cancel from '@/shared/components/Cancel.vue';
    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';

    export default {
        name: 'SpaType',
        components: {
            Cancel,
            SingleImageGallery
        },
        mounted() {
            this.trackSpaOptions();
        },
        computed: {
            isDisabled() {

                return this.spaStatus != null && this.spaStatus.IsDisabled;
            },
            spaStatus() {
                return store.getters.spaSystemStatus;

            },
            session() {
                return store.getters.session;
            },
            configuration() {
                return store.getters.configuration;
            },
            content() {
                return store.getters.configuration.Content.type;
            }
        },
        data() {
            return {

            }
        },
        methods: {
            onBookSpaDay() {

                this.trackSelect(this.content.spaDay.displayName);
                this.$router.push({ name: 'spa_day_search' });
            },
            onBookSpaTreatment() {
                this.trackSelect(this.content.spaTreatment.displayName);
                this.$router.push({ name: 'spa_treatment_search' });
            },
            trackSpaOptions() {

                if (this.$gtm.enabled()) {

                    let items = [];
                    let item = {
                        'item_id': this.content.spaDay.displayName.replaceAll(" ", "_"),
                        'item_name': this.content.spaDay.displayName,
                        'item_list_name': 'Spa Options'
                    };
                    items.push(item);
                    item = {
                        'item_id': this.content.spaTreatment.displayName.replaceAll(" ", "_"),
                        'item_name': this.content.spaTreatment.displayName,
                        'item_list_name': 'Spa Options'
                    };
                    items.push(item);

                    window.dataLayer?.push({
                        'pageURL': '/spa/type',
                        'event': 'view_item_list',
                        'ecommerce': {
                            'item_list_name': 'Spa Options',
                            'items': items
                        }
                    });
                }

            },
            trackSelect(option) {

                if (this.$gtm.enabled()) {
                    let item = {
                        'item_id': option.replaceAll(" ", "_"),
                        'item_name': option,
                        'item_list_name': 'Spa Options'
                    };
                    window.dataLayer?.push({
                        'pageURL': '/spa/type',
                        'event': 'select_item',
                        'ecommerce': {
                            'item_list_name': 'Spa Options',
                            'items': [item]
                        }
                    });
                }


            }

        }
    }
</script>
<style>
    .type-gallery{
        height: 300px;
    }

</style>